import { render, staticRenderFns } from "./package-table-detail.vue?vue&type=template&id=a796f5d4"
import script from "./package-table-detail.vue?vue&type=script&lang=js"
export * from "./package-table-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports